import styled from "styled-components";

export const ScrollToTopButton = styled.div`
	position: fixed;
	bottom: 75px;
	left: calc(50% - 25px);
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 2;

	@media (min-width: 744px) {
		bottom: 100px;
	}

	@media (min-width: 1024px) {
		bottom: 20px;
		left: calc(50% - 30px);
	}

	svg {
		width: 50px;
		height: 50px;

		@media (min-width: 1024px) {
			width: 60px;
			height: 60px;
		}
	}
`;
